/* La Bombilla — panier latéral natif (remplace Monster Cart Upsell).
   - Intercepte les ajouts au panier des fiches produit et ouvre le panier.
   - Re-rend le panier via la Section Rendering API (section « lb-cart-drawer »).
   - Ajoute / retire automatiquement le cadeau selon le seuil. */
(function () {
  if (window.__lbCartDrawerInit) return;
  window.__lbCartDrawerInit = true;

  var SECTION = 'lb-cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var queue = Promise.resolve();

  function drawer() { return document.querySelector('[data-lb-drawer]'); }
  function inner() { var d = drawer(); return d && d.querySelector('[data-lb-drawer-inner]'); }

  function json(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var e = new Error(data.description || data.message || 'Erreur panier'); e.data = data; throw e; }
        return data;
      });
    });
  }

  // Sérialise toutes les opérations panier (évite les courses entre clics rapides et synchro du cadeau).
  function enqueue(fn) {
    queue = queue.then(fn, fn);
    return queue;
  }

  function setLoading(on) {
    var d = drawer();
    if (d) d.classList.toggle('is-loading', !!on);
  }

  function updateCount() {
    var el = inner();
    if (!el) return;
    var count = el.getAttribute('data-item-count');
    document.querySelectorAll('[data-lb-cart-count]').forEach(function (c) { c.textContent = count; });
  }

  function render() {
    return fetch(ROOT + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data[SECTION];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-lb-drawer-inner]');
        var current = inner();
        if (fresh && current) current.replaceWith(fresh);
        updateCount();
      });
  }

  // Retourne true si le panier a été modifié.
  function syncGift() {
    var el = inner();
    if (!el || el.getAttribute('data-gift-enabled') !== 'true') return Promise.resolve(false);
    var variant = parseInt(el.getAttribute('data-gift-variant'), 10);
    var qty = parseInt(el.getAttribute('data-gift-qty'), 10) || 0;
    var threshold = parseInt(el.getAttribute('data-gift-threshold'), 10) || 0;
    var total = parseInt(el.getAttribute('data-eligible-total'), 10) || 0;
    var count = parseInt(el.getAttribute('data-item-count'), 10) || 0;
    if (!variant) return Promise.resolve(false);
    var eligible = total >= threshold && (count - qty) > 0;
    if (eligible && qty === 0) {
      return json('cart/add.js', { items: [{ id: variant, quantity: 1 }] }).then(function () { return true; }, function () { return false; });
    }
    if (!eligible && qty > 0) {
      return json('cart/change.js', { id: String(variant), quantity: 0 }).then(function () { return true; }, function () { return false; });
    }
    if (eligible && qty > 1) {
      return json('cart/change.js', { id: String(variant), quantity: 1 }).then(function () { return true; }, function () { return false; });
    }
    return Promise.resolve(false);
  }

  function refresh() {
    return render().then(syncGift).then(function (changed) { if (changed) return render(); });
  }

  var lastFocus = null;
  function open() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lb-drawer-open');
    var panel = d.querySelector('.lb-drawer__panel');
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
  }
  function close() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lb-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function withLoading(promise) {
    setLoading(true);
    return promise.then(function (v) { setLoading(false); return v; }, function (e) { setLoading(false); throw e; });
  }

  function showError(message) {
    var el = inner();
    if (!el) return;
    var box = el.querySelector('.lb-drawer__error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'lb-drawer__error';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:0;padding:10px 20px;background:#fbe9e4;color:#8a2f17;font-size:13px;text-align:center;';
      var head = el.querySelector('.lb-drawer__head');
      if (head) head.insertAdjacentElement('afterend', box); else el.prepend(box);
    }
    box.textContent = message;
  }

  // --- Ajout depuis une fiche produit ---
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.closest('[data-lb-no-drawer]') || !drawer()) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Ajout en cours…'; }
    var fd = new FormData(form);
    enqueue(function () {
      return fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) { var err = new Error(data.description || 'Impossible d\'ajouter ce produit'); err.soft = true; throw err; }
            return data;
          });
        })
        .then(refresh)
        .then(open)
        .catch(function (err) {
          if (err && err.soft) { return refresh().then(function () { open(); showError(err.message); }); }
          // Réseau / erreur inattendue : on repasse par l'envoi classique du formulaire.
          HTMLFormElement.prototype.submit.call(form);
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; }
        });
    });
  });

  // --- Clics ---
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // Icône panier du header → ouvre le panier (sauf sur la page panier).
    var cartLink = t.closest('a[href="/cart"], a[href="' + ROOT + 'cart"]');
    if (cartLink && !cartLink.closest('[data-lb-drawer]') && drawer() && !/\/cart\/?$/.test(location.pathname)) {
      e.preventDefault();
      open();
      enqueue(function () { return withLoading(refresh()); });
      return;
    }

    if (!t.closest('[data-lb-drawer]')) return;

    if (t.closest('[data-lb-drawer-close]')) { e.preventDefault(); close(); return; }

    var qtyBtn = t.closest('[data-lb-line-key]');
    if (qtyBtn) {
      e.preventDefault();
      var key = qtyBtn.getAttribute('data-lb-line-key');
      var q = Math.max(0, parseInt(qtyBtn.getAttribute('data-lb-qty'), 10) || 0);
      enqueue(function () {
        return withLoading(json('cart/change.js', { id: key, quantity: q }).then(refresh).catch(function (err) {
          return refresh().then(function () { showError(err.message); });
        }));
      });
      return;
    }

    var up = t.closest('[data-lb-upsell-add]');
    if (up) {
      e.preventDefault();
      var id = parseInt(up.getAttribute('data-lb-upsell-add'), 10);
      up.disabled = true; up.textContent = 'Ajout…';
      enqueue(function () {
        return withLoading(json('cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(refresh).catch(function (err) {
          return refresh().then(function () { showError(err.message); });
        }));
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var d = drawer(); if (d && d.classList.contains('is-open')) close(); }
  });

  // Au chargement : on remet le cadeau d'aplomb si le panier a changé ailleurs (autre onglet, checkout abandonné…).
  function boot() {
    enqueue(function () {
      return syncGift().then(function (changed) {
        if (!changed) return;
        // Sur la page panier, on recharge pour afficher le cadeau ajouté / retiré.
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        return render();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.LBCart = { open: open, close: close, refresh: function () { return enqueue(refresh); } };
})();
